<h2 mat-dialog-title>Positionen auswählen</h2>
<mat-dialog-content style="max-height: unset">
    <div class="flex items-center gap-4 w-full" style="position: sticky;">
        <mat-form-field class="grow">
            <mat-label>Suche nach Positionen</mat-label>
            <input type="text" [formControl]="searchForm" matInput />
            <button class="small-icon-btn" matSuffix (click)="searchForm.setValue('')" mat-icon-button *ngIf="searchForm.value">
                <fa-icon icon="times"></fa-icon>
            </button>
        </mat-form-field>
<!--        <button-->
<!--            app-round-button-->
<!--            Inverted-->
<!--            [matBadge]="FilterAmount$ | async"-->
<!--            matTooltip="Filter"-->
<!--            [matBadgeOverlap]="true"-->
<!--            [matBadgeHidden]="!(FilterAmount$ | async)"-->
<!--            (click)="filter.Open()"-->
<!--        >-->
<!--            <fa-icon icon="filter"></fa-icon>-->
<!--        </button>-->
    </div>
    <mat-form-field class="w-full">
        <app-select-search
            [placeholder]="supplierLabel$ | async"
            [Options]="suppliers$ | async"
            [formControl]="supplierForm"
        ></app-select-search>
    </mat-form-field>
<!--    <app-filter-card UnlimitedHeight #filter [Settings]="FilterSettings$ | async" [Values]="FilterValues$ | async" (ValuesChange)="FilterValues$.next($event)"></app-filter-card>-->
    <div style="height: 50vh; flex-grow: 1;" class="scroll">

        <table mat-table class="w-full">
            <ng-container matColumnDef="select" sticky="true">
                <th mat-header-cell *matHeaderCellDef>
                    <mat-checkbox (change)="$event ? toggleAllRows() : null" [checked]="selection.hasValue() && isAllSelected()"> </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row">
                    <mat-checkbox (click)="$event.stopPropagation()" (change)="checkBoxChange(row)" [checked]="selection.isSelected(row)" [disabled]="!row.matchedArlId"> </mat-checkbox>
                </td>
            </ng-container>
            <ng-container *ngFor="let col of currencyColumns" [matColumnDef]="col.columnName">
                <th mat-header-cell *matHeaderCellDef>{{ col.header }}</th>
                <td mat-cell *matCellDef="let row">{{ row[col.columnName] | number: '1.2-2' }}</td>
            </ng-container>
            <ng-container *ngFor="let col of textColumns" [matColumnDef]="col.columnName">
                <th mat-header-cell *matHeaderCellDef>{{ col.header }}</th>
                <td mat-cell *matCellDef="let row">{{ row[col.columnName] }}</td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" [attr.colspan]="displayedColumns.length">
                    <span *ngIf="!searchForm.value">Es sind keine Positionen vorhanden.</span>
                    <span *ngIf="searchForm.value as searchQuery">Keine Positionen mit "{{searchQuery}}" gefunden</span>
                </td>
            </tr>
        </table>
    </div>
    <app-mat-paginator-wrapper>
        <mat-paginator #paginator [length]="(datasource?.data.length)" [pageIndex]="0" [pageSize]="25" [pageSizeOptions]="[10, 25, 50]" showFirstLastButtons aria-label="Seite wählen"> </mat-paginator>
    </app-mat-paginator-wrapper>
</mat-dialog-content>
<mat-dialog-actions class="justify-between gap-2">
    <button app-button Inverted Color="cancel" matDialogClose>abbrechen</button>
    <button app-button Color="green" [matDialogClose]="{arls: selection.selected, supplierId: supplierForm.getRawValue()?.Id}" [Disabled]="selection.isEmpty()">Preise überschreiben</button>
</mat-dialog-actions>
